import * as React from "react";
import classnames from "classnames";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { FmText } from "../FmText";
import useStyles from "./FmDropdownInput.style";

type FmDropDownVariant = "standard" | "outlined" | "filled";

interface FmDropdownInputProps {
  options: { key: string; value: any }[];
  selectedOptionKey?: string;
  icon?: any;
  onOptionSelect?: (key: string) => void;
  variant?: FmDropDownVariant;
  className?: string;
}

export default function FmDropdownInput({ icon, options, selectedOptionKey, onOptionSelect, variant = "standard", className }: FmDropdownInputProps) {
  const classes = useStyles();

  const handleChange = (event: SelectChangeEvent) => onOptionSelect && onOptionSelect(event.target.value);

  const MenuProps = {
    PaperProps: {
      style: {
        width: "auto",
        minWidth: "180px",
        boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
        borderRadius: "8px",
      },
    },
  };

  return (
    <div className={classnames(classes.container, className)}>
      {icon && <div className={classes.iconContainer}>{icon}</div>}
      <FormControl>
        <Select
          disableUnderline
          value={selectedOptionKey}
          onChange={handleChange}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          variant={variant}
          MenuProps={MenuProps}
        >
          {options.map((option: { key: string; value: any }) => (
            <MenuItem key={option.key} value={option.key}>
              <FmText>{option.value}</FmText>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
